import dayjs from 'dayjs';

const handleDates = (dates) => {
  let updateAt = '';
  const years = dayjs().diff(dates, 'years');
  const month = dayjs().diff(dates, 'months');
  const day = dayjs().diff(dates, 'day');
  const hours = dayjs().diff(dates, 'hours');
  const minutes = dayjs().diff(dates, 'minutes');
  const seconds = dayjs().diff(dates, 'seconds');

  if (years > 0) {
    updateAt = `${years} years ago`;
  } else if (month > 0) {
    updateAt = `${month} month ago`;
  } else if (day > 0) {
    updateAt = `${day} day ago`;
  } else if (hours > 0) {
    updateAt = `${hours} hours ago`;
  } else if (minutes > 0) {
    updateAt = `${minutes} minutes ago`;
  } else {
    updateAt = `${seconds} seconds ago`;
  }

  return updateAt;
};

export default handleDates;
